
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/2fa",
      function () {
        return require("private-next-pages/2fa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/2fa"])
      });
    }
  